import DemoScreen from "./DemoScreen";
import WithResposiveUtils from "../../utils/ResponsiveUtils";

export default WithResposiveUtils(DemoScreen);
